import { createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-da17faec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-signin" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "h3 mb-3 fw-normal" }, "Add Peak Factor ", -1))
const _hoisted_3 = { class: "form-floating" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<option value=\"Sunday\" data-v-da17faec>Sunday</option><option value=\"Monday\" data-v-da17faec>Monday</option><option value=\"Tuesday\" data-v-da17faec>Tuesday</option><option value=\"Wednesday\" data-v-da17faec>Wednesday</option><option value=\"Thursday\" data-v-da17faec>Thursday</option><option value=\"Friday\" data-v-da17faec>Friday</option><option value=\"Saturday\" data-v-da17faec>Saturday</option>", 7)
const _hoisted_11 = [
  _hoisted_4
]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "Day Name ", -1))
const _hoisted_13 = { class: "form-floating" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "Peak Factor Value", -1))
const _hoisted_15 = { class: "form-floating" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "0" }, "0", -1))
const _hoisted_17 = ["value"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "Start Time ", -1))
const _hoisted_19 = { class: "form-floating" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "0" }, "0", -1))
const _hoisted_21 = ["value"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "End Time ", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "w-100 btn btn-lg btn-primary",
  type: "submit"
}, "Submit", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("form", {
      onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => ($setup.submit && $setup.submit(...args)), ["prevent"]))
    }, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.data.day_name) = $event)),
          class: "form-control",
          required: ""
        }, _hoisted_11, 512), [
          [_vModelSelect, $setup.data.day_name]
        ]),
        _hoisted_12
      ]),
      _createElementVNode("div", _hoisted_13, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.data.peak_factor) = $event)),
          class: "form-control",
          placeholder: "1",
          required: ""
        }, null, 512), [
          [_vModelText, $setup.data.peak_factor]
        ]),
        _hoisted_14
      ]),
      _createElementVNode("div", _hoisted_15, [
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.data.time_start) = $event)),
          class: "form-control",
          required: ""
        }, [
          _hoisted_16,
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(23, (n) => {
            return _createElementVNode("option", {
              value: n,
              key: n
            }, _toDisplayString(n), 9, _hoisted_17)
          }), 64))
        ], 512), [
          [_vModelSelect, $setup.data.time_start]
        ]),
        _hoisted_18
      ]),
      _createElementVNode("div", _hoisted_19, [
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.data.time_end) = $event)),
          class: "form-control",
          required: ""
        }, [
          _hoisted_20,
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(23, (n) => {
            return _createElementVNode("option", {
              value: n,
              key: n
            }, _toDisplayString(n), 9, _hoisted_21)
          }), 64))
        ], 512), [
          [_vModelSelect, $setup.data.time_end]
        ]),
        _hoisted_22
      ]),
      _hoisted_23
    ], 32)
  ]))
}